import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { QuantityStripper } from "../../../../Layout/Common/quantityStripper";
import { ConvertToFloat, isValidArray } from "../../../../Layout/Common/common";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import { RemoveWhishList } from "./removeWhishList";
import { handleStockStatus } from "../../../../utils/stockStatus";
import { PriceStockPopup } from "../../../../Layout/Common/priceStockPopup";
import { ProductLink } from "../../../../Layout/Common/productLink";

export const ProductCardList = ({ data, index, updateList }) => {
  const { CartItem } = useContext(GlobalContext);
  const [productStock, setProductStock] = useState(null);
  const [ProductData, setProductData] = useState(null);
  const [qty, setQty] = useState(null);

  useEffect(() => {
    if (data) {
      setProductData(data);
      if (data.stockStatus) {
        const status = handleStockStatus(data.stockStatus);
        setProductStock(status);
      }
    }
  }, [data]);

  useEffect(() => {
    if (!ProductData) return;
    if (ProductData && CartItem && isValidArray(CartItem.cartItem)) {
      var products = CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(ProductData.productId));
      setQty({
        prod_id: ProductData.productId,
        qty: filterProductId?.qty ?? 0,
      });
    } else {
      setQty({ prod_id: ProductData?.productId, qty: 0 });
    }
  }, [CartItem, ProductData]);

  return (
    <Fragment>
      {ProductData && (
        <div className="col-sm-12 col-md-12 mt-3 mt-lg-4" key={ProductData.productId}>
          <div className="search-row position-relative">
            <div className="search-row-products">
              <div className="ct-row-products fav-row-products">
                <div className="row-pro-img">
                  <ProductLink to={ProductData.link}>
                    <ImageWithDefault src={data.prodImage} alt="product-name" />
                  </ProductLink>
                </div>
                <div className="row-products-details">
                  <h6 className="product-title">
                    <ProductLink to={ProductData.link}>{ProductData.description}</ProductLink>
                  </h6>
                  {productStock && (
                    <Fragment>
                      {productStock.isSubstitute ? (
                        <Fragment>
                          <div className="product-unavailable">
                            <p>Substituted</p>
                          </div>
                          <div className="product-code product-substituted">
                            <p>
                              Replacement:
                              <Link to={productStock.redirectUrl}>{productStock.substituteCode}</Link>
                            </p>
                          </div>
                        </Fragment>
                      ) : productStock.isShowBuy == false ? (
                        <Fragment>
                          <div className="product-unavailable">
                            <p>Discontinued</p>
                          </div>
                        </Fragment>
                      ) : (
                        <div className="product-features fav-product-feature">
                          <p>${ConvertToFloat(ProductData.price ?? 0)}</p>
                          <div className="favPro-codeAvail">
                            <div className="product-code">Code: {ProductData.productCode}</div>
                            <div className="favAvailablity fs-14">
                              <span className="bg-grey">Availability : </span>
                              <span className="favStocks">{ProductData.stockStatus.stockStatusRaw}</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
              <div className="ct-row-info position-relative">
                <div className="wishlist-products row-wishlist-products fav-wishlist-products">
                  <p className="wishlistRow">
                    <RemoveWhishList product={ProductData} updateList={updateList} view="row" />
                  </p>

                  {productStock && (
                    <Fragment>
                      {productStock.isSubstitute ? (
                        <div className="product-button">
                          <button type="button" className="btn btn-products btn-unavailable">
                            Discontinued
                          </button>
                        </div>
                      ) : productStock.isShowBuy == false ? (
                        <div className="product-button">
                          <button type="button" className="btn btn-products btn-unavailable">
                            {ProductData.stockStatus.stockStatusRaw}
                          </button>
                        </div>
                      ) : (
                        <Fragment>
                          <span className="favOrder-status">
                            <PriceStockPopup product={ProductData} />
                          </span>
                          {qty && (
                            <QuantityStripper
                              prd={qty}
                              params={{
                                code: ProductData.productCode,
                                desc: ProductData.description,
                                img: ProductData.prodImage,
                              }}
                            />
                          )}
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
